 /* eslint-disable */
// Posts Slider plugin:

(function($) {
	var $postsSlider = $.postsSlider = function(){
		return $(window).postsSlider();
	};

	$.fn.postsSlider = function(enabled, gsap){

		return this.each(function() {
      $hammer = $(this).hammer({domEvents:true});

			//Slider elements
			var $slider = $(this).find('.posts-wrap');
			var $row = $slider.find('.row');
			var $col = $slider.find('.col');

			//Slider controls
			var $prev = $(this).find('[data-slide="prev"]');
			var $next = $(this).find('[data-slide="next"]');

			//Measurements
			var sliderWidth;
			var rowWidth;
			var tileWidth;
			var sliderPadding;
			var visibleTiles;
			var minScroll;
			var maxScroll;
			var curx;
			var iTile = 0;
			var iMax;

			var isPanning = false;
			var isScrolling = false;

			var classes = $col.attr('class');

      // $slider.find('.col a').removeClass('stretched-link');

			//Toggle controls visilbility
			function toggleControls(){
				var duration = 0.5;
				if (!iMax){
					gsap.to($prev, duration, {autoAlpha:0});
					gsap.to($next, duration, {autoAlpha:0});
				} else if (iTile <= 0){
					gsap.to($prev, duration, {autoAlpha:0});
					gsap.to($next, duration, {autoAlpha:1});
				}else if (iTile >= iMax) {
					gsap.to($next, duration, {autoAlpha:0});
					gsap.to($prev, duration, {autoAlpha:1});
				} else {
					gsap.to($prev, duration, {autoAlpha:1});
					gsap.to($next, duration, {autoAlpha:1});
				}
			}

			//Scroll tiles left or right
			function scrollTiles(dir, deltaX){
				//if (isScrolling) {return;}
        // console.log('ScrollTiles');

				iTile += dir * visibleTiles;
				iTile = Math.max(0, Math.min(iMax, iTile));

				var delta = tileWidth * iTile * -1;

				toggleControls();

				isScrolling = true;
				var duration = 1;
        gsap.to($row, duration, {x:delta, ease:'circ.out', onComplete: function(){
					isScrolling = false;
				}});
			}

			//Reflow tiles based on screen width
			function scaleSlider(){
				if (!enabled) {
					return;
				}
				$col.addClass(classes);
				$row.css('width', '');
				rowWidth = 0;
				$col.each(function(){
					var $this = $(this);
					$this.css('width', '');
					tileWidth = $this.outerWidth();
					$this.css('width', tileWidth);
					rowWidth += tileWidth;
				});

				$col.removeClass().addClass('column');

				$row.css('width', rowWidth);
				sliderWidth = $slider.outerWidth();

				sliderPadding = parseInt($slider.css('paddingLeft'), 10);
				visibleTiles = Math.round(sliderWidth/tileWidth);


				maxScroll = -(rowWidth - sliderWidth + sliderPadding * 1.5) ;
				minScroll = 0;
				iMax = $col.length - visibleTiles ;
        // console.log('scale', iMax, $col.length, visibleTiles, sliderWidth/tileWidth);

				isPanning = false;
				scrollTiles(0);
				toggleControls();
			}

			function scrollNext(e) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				scrollTiles(1);
			}

			function scrollPrev(e){
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				scrollTiles(-1);
      }

      function getX (obj){
        var t = (obj[0] === undefined ) ? obj : obj[0];
        // return t._gsTransform.x;
        return gsap.getProperty(t, "x");
      }

			$slider.find('a').on('click mouseover', function(e){
				if (isPanning){
					e.preventDefault();
					e.stopPropagation();
				}
			});

			function enableSlider(){
				//Initiate slider elements and controls
				enabled = true;
				$slider.addClass('posts-slider').removeClass('posts-slider-disabled');
				iTile = 0;
				gsap.set($row, {css:{x:0}});
				$next.show();
				$prev.show();
				gsap.set($prev, {autoAlpha:0});

        window.addEventListener('resize', scaleSlider);
        window.addEventListener('orientationchange', scaleSlider);
        scaleSlider();
        setTimeout(scaleSlider, 500);

				$next.on('click', scrollNext);
				$prev.on('click', scrollPrev);

				$slider.on('dragstart', function(e) { e.preventDefault();});


				if ($hammer){
				// listen to touch events
					$hammer.on("panleft panright panend pancancel", '.posts-slider', function(e) {
							if (!enabled) {
								return;
							}
							e.preventDefault();
							e.stopPropagation();

						   var evt = e.originalEvent;
						    if (!evt) {
							   return;
						   }

							//if (isScrolling) {return;}
							var deltaX = evt.gesture.deltaX;

							 switch(evt.type) {
								 case 'panend':
								 if (Math.abs(deltaX) < tileWidth/4) {
									scrollTiles(0);
								 }else{
									 var dir = deltaX > 0 ? -1 : 1;
									 scrollTiles(dir, deltaX);
								 }

								 setTimeout(function(){ isPanning = false; }, 100);
								 break;

								 case 'panleft':
								 case 'panright':
								 if (!isPanning){
                  //  curx = GreenProp.x($row);
                  curx = getX($row);
									 isPanning = true;
								 }
								// var pos = Math.max(maxScroll, Math.min(minScroll, curx + deltaX));
								var pos = curx + deltaX;
								 gsap.set($row, {x: pos});
							}
					});
				}

        //Cancel pan on click outside
        $(document).on('mouseup', function(e) {
          if (isPanning && !$(e.target).parents('.posts-wrap').length) {
            scrollTiles(0);
          }
        });

      }

			function disableSlider(){
				enabled = false;
				$slider.css('visibility', 'visible');
				$slider.addClass('posts-slider-disabled').removeClass('posts-slider');
				$next.hide();
				$prev.hide();
				$slider.off('dragstart');
				$row.css('width', '');
				rowWidth = 0;
				$col.each(function(){
					var $this = $(this);
					$this.css('width', '');
				});
				gsap.set($row, {css:{x:0}});
			}


			if (enabled) {
				enableSlider();
				//gsap.from($slider, 1, {alpha: 0});
			}else {
				$slider.css('visibility', 'visible');
				$slider.addClass('posts-slider-disabled');
			}

			$slider.data('enableSlider', enableSlider);
			$slider.data('disableSlider', disableSlider);
   		});
	};
})(jQuery);

